// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","138":"profile","594":"demo"}[chunkId] || chunkId) + "." + {"94":"dfe86659","138":"41bbfa70","594":"a2c42877","827":"0698160c"}[chunkId] + ".js";
};